var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_80_617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8846 26.8675L26.1007 6.7634C26.0686 6.36556 25.735 6.06396 25.3307 6.06396H21.5704C21.564 2.72076 18.8432 0 15.5 0C12.1568 0 9.43606 2.72076 9.42964 6.06396H5.66934C5.27149 6.06396 4.93781 6.36556 4.89931 6.7634L3.11542 26.8675C3.11542 26.8932 3.11542 26.9124 3.11542 26.9381C3.11542 29.1776 5.17524 31 7.70349 31H23.2965C25.8248 31 27.8846 29.1776 27.8846 26.9381C27.8846 26.9124 27.8846 26.8932 27.8846 26.8675ZM15.5 1.54005C17.9962 1.54005 20.0239 3.56779 20.0303 6.06396H10.9697C10.9761 3.56779 13.0038 1.54005 15.5 1.54005ZM23.2965 29.4535H7.70349C6.0351 29.4535 4.67472 28.3434 4.65547 26.9638L6.3752 7.60402H9.42964V10.3055C9.42964 10.729 9.77615 11.0756 10.1997 11.0756C10.6232 11.0756 10.9697 10.729 10.9697 10.3055V7.60402H20.0303V10.3055C20.0303 10.729 20.3769 11.0756 20.8004 11.0756C21.2239 11.0756 21.5704 10.729 21.5704 10.3055V7.60402H24.6248L26.3446 26.9702C26.3253 28.3434 24.9649 29.4535 23.2965 29.4535Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80_617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStock);
export default __webpack_public_path__ + "static/media/stock.57f3d5d9b601b9cde29a03c13cd0ea70.svg";
export { ForwardRef as ReactComponent };